const T = 2e3;
export {
  T as DEFAULT_WATER_TARGET_ML
};
